import { calcularRangoPeriodo, type TipoPeriodo } from "../lib/periodo";
import { Input, Select } from "./Formulario";

const ETIQUETAS: Record<TipoPeriodo, string> = {
  hoy: "Hoy",
  manana: "Mañana",
  semana: "Esta semana",
  semana_proxima: "Próxima semana",
  mes: "Este mes",
  mes_proximo: "Próximo mes",
  personalizado: "Personalizado",
};

const OPCIONES: TipoPeriodo[] = ["hoy", "manana", "semana", "semana_proxima", "mes", "mes_proximo", "personalizado"];

export interface PeriodoSeleccionado {
  tipo: TipoPeriodo;
  desde: string;
  hasta: string;
}

export function periodoInicial(): PeriodoSeleccionado {
  return { tipo: "hoy", ...calcularRangoPeriodo("hoy") };
}

// Selector superior de período — el backend nunca ve el preset elegido,
// sólo recibe desde/hasta ya resueltos (ver src/lib/periodo.ts). Al elegir
// "Personalizado" se muestran dos inputs de fecha, mismo patrón ad-hoc ya
// usado en EconomiaPage.tsx (dos <Input type="date"> lado a lado).
export function SelectorPeriodo({
  valor,
  onCambiar,
}: {
  valor: PeriodoSeleccionado;
  onCambiar: (p: PeriodoSeleccionado) => void;
}) {
  function cambiarTipo(tipo: TipoPeriodo) {
    if (tipo === "personalizado") {
      onCambiar({ tipo, desde: valor.desde, hasta: valor.hasta });
      return;
    }
    onCambiar({ tipo, ...calcularRangoPeriodo(tipo) });
  }

  return (
    <div className="flex flex-wrap items-end gap-3">
      <label className="block">
        <span className="mb-1 block text-sm font-medium text-texto">Período</span>
        <Select value={valor.tipo} onChange={(e) => cambiarTipo(e.target.value as TipoPeriodo)}>
          {OPCIONES.map((o) => (
            <option key={o} value={o}>
              {ETIQUETAS[o]}
            </option>
          ))}
        </Select>
      </label>
      {valor.tipo === "personalizado" && (
        <>
          <label className="block">
            <span className="mb-1 block text-sm font-medium text-texto">Desde</span>
            <Input
              type="date"
              value={valor.desde}
              max={valor.hasta || undefined}
              onChange={(e) => onCambiar({ ...valor, desde: e.target.value })}
            />
          </label>
          <label className="block">
            <span className="mb-1 block text-sm font-medium text-texto">Hasta</span>
            <Input
              type="date"
              value={valor.hasta}
              min={valor.desde || undefined}
              onChange={(e) => onCambiar({ ...valor, hasta: e.target.value })}
            />
          </label>
        </>
      )}
    </div>
  );
}
